import { tosDate } from "./tos.constant";

export default function TermsOfService() {
  return (
    <div className="terms-of-service">
      <h1>Terms of Service</h1>
      <p>
        <strong>Effective Date:</strong> {tosDate}
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using Liberty Connect, LLC (&quot;the Site&quot;), you
        agree to comply with and be bound by these Terms of Service
        (&quot;TOS&quot;). If you do not agree with any part of these terms, you
        must not use the Site.
      </p>

      <h2>2. Changes to Terms</h2>
      <p>
        Liberty Connect, LLC reserves the right to update or modify these Terms
        at any time without prior notice. Any changes will be posted on this
        page, and your continued use of the Site after such changes constitutes
        your acceptance of the modified terms.
      </p>

      <h2>3. Eligibility</h2>
      <p>
        To use the Site, you must be at least 18 years of age. By using the
        Site, you represent and warrant that you are of legal age to form a
        binding contract in your jurisdiction.
      </p>

      <h2>4. Account Registration</h2>
      <p>If you create an account on the Site, you agree to:</p>
      <ul>
        <li>Provide accurate, complete, and up-to-date information.</li>
        <li>Maintain the confidentiality of your account and password.</li>
        <li>Notify us immediately of any unauthorized use of your account.</li>
      </ul>
      <p>You are solely responsible for all activity under your account.</p>

      <h2>5. User Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Site for any unlawful purpose.</li>
        <li>Violate any applicable local, state, or international laws.</li>
        <li>
          Engage in harmful conduct or transmit harmful content (e.g., viruses,
          malware).
        </li>
        <li>Infringe upon intellectual property rights of others.</li>
        <li>
          Post or share abusive, harassing, defamatory, or otherwise
          inappropriate content.
        </li>
      </ul>

      <h2>6. Content Ownership</h2>
      <p>
        <strong>Your Content:</strong> You retain ownership of any content you
        upload, submit, or share on the Site, but you grant Liberty Connect, LLC
        a worldwide, royalty-free, transferable license to use, display, and
        distribute your content as part of the operation of the Site.
      </p>
      <p>
        <strong>Our Content:</strong> All content provided by Liberty Connect,
        LLC (such as text, graphics, logos, and software) is the property of
        Liberty Connect or its licensors and is protected by copyright,
        trademark, and other intellectual property laws.
      </p>

      <h2>7. Privacy Policy</h2>
      <p>
        Your use of the Site is also governed by our{" "}
        <a href="/page/privacy">Privacy Policy</a>. By using the Site, you
        consent to the practices described in the Privacy Policy.
      </p>

      <h2>8. Third-Party Links</h2>
      <p>
        The Site may contain links to third-party websites. We are not
        responsible for the content or practices of these external sites, and
        you access them at your own risk.
      </p>

      <h2>9. Termination</h2>
      <p>
        We may suspend or terminate your access to the Site, without notice, for
        any reason, including violation of these Terms. Upon termination, you
        must immediately cease using the Site, and any rights granted to you
        under these Terms will be revoked.
      </p>

      <h2>10. Disclaimers and Limitation of Liability</h2>
      <p>
        The Site is provided &quot;as is&quot; without warranties of any kind,
        either express or implied. We do not guarantee the accuracy,
        completeness, or reliability of the content on the Site or searches
        provided through the Site. Liberty Connect, LLC will not be liable for
        any damages arising from your use or inability to use the Site.
      </p>

      <h2>11. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless Liberty Connect, LLC, its
        affiliates, and their respective officers, directors, employees, and
        agents from any claims, losses, or damages, including legal fees,
        arising from your use of the Site or violation of these Terms.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the
        laws of New York State. Any disputes arising from these Terms shall be
        resolved in the courts of Queens County, New York.
      </p>

      <h2>13. Contact Information</h2>
      <p>
        If you have any questions or concerns about these Terms, please contact
        us at: info@libertyconnect.nyc
      </p>
    </div>
  );
}
